export default __webpack_public_path__ + "static/media/assignment.0903fe0f.png";